<template>
  <nav
    class="navbar navbar-expand-lg mb-0"
    :class="`${
      user?.isAdmin
        ? 'admin'
        : user?.isManagingAdmin
        ? 'managing-admin'
        : user?.isProvider
        ? 'provider'
        : 'client'
    }-user-navbar ${scrolled ? 'shadow-nav' : ''}`"
  >
    <div class="container-fluid navbar-app-shell px-3 px-lg-4">
      <div
        class="
          no-wrap
          p-0
          mobile-header-container
          authed-navbar-inner
          d-flex
          align-items-center
          flex-nowrap
          w-100
        "
      >
        <div
          class="
            authed-navbar-brand-cluster
            d-flex
            align-items-center
            min-w-0
            flex-shrink-1
          "
        >
          <button
            v-if="user"
            class="
              btn btn-link
              d-lg-none
              authed-sidebar-toggle
              p-0
              navbar-toggler
              collapsed
            "
            type="button"
            aria-label="Open navigation menu"
            @click="$emit('open-sidebar')"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <img class="site-logo" :src="companyLogo || companyLogoPlaceholder" />
          <router-link
            ref="companyNameDesktop"
            class="navbar-brand company-name-desktop d-none d-lg-block"
            v-tooltip.bottom="isCompanyNameTruncated ? companyName : false"
            to="/dashboard"
          >
            {{ companyName }}
          </router-link>
          <!-- <router-link
            class="
              navbar-brand
              company-name-mobile
              d-lg-none
              mb-0
              ml-2
              text-truncate
              flex-grow-1
              min-w-0
            "
            :title="companyName"
            to="/dashboard"
          >
            {{ companyName }}
          </router-link> -->
        </div>

        <div class="authed-navbar-actions flex-shrink-0">
          <ul class="navbar-nav icons-navbar-nav authed-navbar-tools">
            <li
              class="nav-item position-relative search-nav-item"
              v-if="user && !user.isPatient"
            >
              <label
                :data-state="searchState"
                for="search"
                class="jump-label"
                :title="
                  searchState == 'open'
                    ? ''
                    : user.isProvider
                    ? $customerLabel
                      ? `Jump to any ${$customerLabel({
                          type: 'singular',
                          capitalize: false,
                        })}...`
                      : 'Jump to any client...'
                    : 'Jump to anyone...'
                "
              >
                <input
                  type="text"
                  :placeholder="
                    user.isProvider
                      ? $customerLabel
                        ? `Jump to any ${$customerLabel({
                            type: 'singular',
                            capitalize: false,
                          })}...`
                        : 'Jump to any client...'
                      : 'Jump to anyone...'
                  "
                  @click="searchState = 'open'"
                  v-model="searchKey"
                  @blur="searchBlured"
                />
                <i
                  :class="
                    searchState == 'open' ? 'fa fa-times' : 'fa fa-search'
                  "
                  aria-hidden="true"
                ></i>
                <ul class="search-result_users">
                  <li
                    class="text-center p-3 h3 m-0"
                    v-if="!loading && !filteredUsers.length && searchKey"
                  >
                    No users found.
                  </li>
                  <li
                    class="text-center p-3 h3 m-0"
                    v-if="!loading && !filteredUsers.length && !searchKey"
                  >
                    No users to search for.
                  </li>
                  <alert v-if="loading" class="m-0" />
                  <li
                    v-for="userItem in filteredUsers"
                    :key="userItem.username"
                    @click="navigateToUser(userItem)"
                    class="pointer-cursor"
                  >
                    <div
                      class="
                        d-flex
                        justify-content-between
                        jump-list-item
                        align-items-center
                      "
                    >
                      <div
                        class="jump-list-name"
                        :class="`${
                          userItem.status != 'INACTIVE' ? '' : 'text-danger'
                        }`"
                      >
                        {{ userItem.name }}
                      </div>
                      <div
                        class="jump-list-role text-bold text-primary"
                        :class="`${
                          userItem.status != 'INACTIVE'
                            ? 'text-primary'
                            : 'text-danger'
                        }`"
                      >
                        {{ getRoleName(parseInt(userItem.roleId)) }}
                      </div>
                      <div
                        class="delete-user-icon text-danger"
                        v-if="
                          user &&
                          user.isAdmin &&
                          user.email == 'eng.karam.eqhash@gmail.com'
                        "
                        @click.stop="deleteUser(userItem.user_id)"
                      >
                        <i class="fa fa-trash" />
                      </div>
                    </div>
                  </li>
                </ul>
              </label>
            </li>
            <li
              class="nav-item nav-theme-color-item pointer-cursor mr-2"
              v-if="user"
            >
              <div
                class="nav-item theme-color-item"
                @click="showThemeModal = true"
              >
                <img
                  class="pallete-img"
                  :src="palleteImg"
                  title="Theme"
                  alt=""
                />
              </div>
            </li>
            <li
              class="
                nav-item nav-theme-color-item
                pointer-cursor
                mr-2
                nav-settings-item
              "
              v-if="
                user &&
                !user.isManagingAdmin &&
                (user.isAdmin || user.isManagingAdmin)
              "
            >
              <div
                class="nav-item theme-color-item"
                @click="navigateToSettings"
              >
                <i class="fas fa-cog fa-lg text-main" title="Settings" />
              </div>
            </li>
            <li class="nav-item nav-create-task-item mr-2 nav-my-profile">
              <div
                class="nav-create-task pointer-cursor"
                @click="navigateToProfile"
              >
                <div class="nav-item create-task-item create-task-modal">
                  <i class="far fa-user fa-lg text-main" title="My Profile" />
                </div>
              </div>
            </li>
            <li
              class="nav-item nav-create-task-item"
              v-if="user && !user.isPatient"
            >
              <div class="nav-create-task">
                <div class="nav-item create-task-item create-task-modal">
                  <i
                    class="far fa-edit pointer-cursor fa-lg text-main"
                    title="Create Task"
                    @click="openCreateTaskModal"
                  />
                  <sidebar
                    :toggle="openModal"
                    @close="closeCreateTaskModal"
                    class="create-task-modal"
                  >
                    <Create
                      :insideModal="true"
                      @saved="taskSaved"
                      :noRedirect="true"
                      :key="modalKey"
                      v-if="openModal"
                    ></Create>
                  </sidebar>
                </div>
              </div>
            </li>
            <pending-notifications />
          </ul>
        </div>
      </div>
    </div>
    <theme-modal v-model="showThemeModal"></theme-modal>
    <sidebar
      v-if="user && user.isPatient"
      :toggle="patientOpenModal"
      @close="closePatientCreateTaskModal"
      class="create-task-modal"
    >
      <PatientCreate
        :insideModal="true"
        @saved="patientTaskSaved"
        :noRedirect="true"
        :defaultTaskType="7"
        :defaultPriority="2"
        :key="patientModalKey"
        v-if="patientOpenModal"
      ></PatientCreate>
    </sidebar>
  </nav>
</template>

<script>
import PendingNotifications from "@/components/PendingNotifications.vue";
import { mapState, mapActions } from "vuex";
import { default as Create } from "../views/tasks/Create";
import { default as PatientCreate } from "../views/tasks/Create";
import ThemeModal from "./Themes/ThemeModal.vue";

export default {
  components: {
    Create,
    PatientCreate,
    ThemeModal,
    PendingNotifications,
  },
  emits: ["open-sidebar"],
  data() {
    return {
      loading: true,
      showThemeModal: false,
      palleteImg: require("@/assets/img/icons/pallete.png"),
      scrolled: false,
      openModal: false,
      searchState: "close",
      searchKey: "",
      modalKey: 1,
      patientOpenModal: false,
      patientModalKey: 1,
      companyLogoPlaceholder: require("@/assets/img/c3-logo.png"),
      isCompanyNameTruncated: false,
    };
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.checkCompanyNameTruncation);
  },
  mounted() {
    this.listenToServerEvents();
    this.getAllUsers().then(() => {
      this.loading = false;
    });
    this.$nextTick(this.checkCompanyNameTruncation);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.checkCompanyNameTruncation);
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      allUsers: (state) => state.security.usersWithRoles,
      companyName: (state) => (state.settings.companyProfile || {}).name || "",
      companyLogo: (state) => state.settings.companyLogo,
    }),
    filteredUsers: function () {
      if (!this.searchKey) {
        return this.allUsers || [];
      }
      return (this.allUsers || []).filter(
        (item) =>
          item.name.toLowerCase().indexOf(this.searchKey.toLowerCase()) > -1
      );
    },
  },
  watch: {
    companyName() {
      this.$nextTick(this.checkCompanyNameTruncation);
    },
    user: {
      immediate: true,
      handler(newUser) {
        if (newUser && newUser.isPatient) {
          window.openCreateTaskModal = this.openPatientCreateTaskModal;
        } else if (newUser) {
          window.openCreateTaskModal = this.openCreateTaskModal;
        }
      },
    },
  },
  methods: {
    ...mapActions({
      getAllUsers: "security/getUsersWithRoles",
      updateOneChartNotesInfo: "oneai/updateOneChartNotesInfo",
    }),
    listenToServerEvents() {
      if (!window.Echo || !window.Echo.encryptedPrivate) {
        return;
      }
      window.Echo.encryptedPrivate("onechart-notes-info").listen(
        "OneChartAiNotesInfo",
        (event) => {
          if (event.environment_name != this.companyName) return;
          if (event?.data) {
            this.updateOneChartNotesInfo(event.data);
          }
        }
      );
    },
    checkCompanyNameTruncation() {
      const ref = this.$refs.companyNameDesktop;
      const el = ref && ref.$el ? ref.$el : ref;
      if (el) {
        this.isCompanyNameTruncated =
          el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth;
      }
    },
    handleScroll() {
      if (window.scrollY > 50) {
        this.scrolled = true;
      } else {
        this.scrolled = false;
      }
    },
    navigateToProfile: function () {
      if (this.user) {
        if (this.user.isAdmin || this.user.isManagingAdmin) {
          this.$router.push({ path: "/admin/profile" });
        } else if (this.user.isProvider) {
          this.navigateToProviderDetails();
        } else if (this.user.isPatient) {
          this.navigateToPatientDetails();
        }
      }
    },
    navigateToProviderDetails: function () {
      this.$router.push({ path: `/providers/${this.user.provider_id}` });
    },
    navigateToPatientDetails: function () {
      this.$router.push({ path: `/clients/${this.user.patient_id}` });
    },
    navigateToSettings: function () {
      this.$router.push({ path: "/admin/settings" });
    },
    navigateToUser: function (userItem) {
      if (userItem.roleId == 1 || userItem.roleId == 5) {
        this.$router.push({ path: "/loading" });
        setTimeout(() => {
          this.$router.replace({ path: `/admin/users/${userItem.id}` });
        }, 500);
      } else if (userItem.roleId == 2) {
        this.$router.push({ path: "/loading" });
        setTimeout(() => {
          this.$router.replace({ path: `/providers/${userItem.id}` });
        }, 500);
      } else {
        this.$router.push({ path: "/loading" });
        setTimeout(() => {
          this.$router.replace({ path: `/clients/${userItem.id}` });
        }, 500);
      }
    },
    openCreateTaskModal: function () {
      this.openModal = true;
    },
    closeCreateTaskModal: function () {
      this.openModal = false;
      window.localStorage.removeItem("task_form");
    },
    taskSaved: function () {
      this.openModal = false;
      window.localStorage.removeItem("task_form");
      this.modalKey++;
    },
    openPatientCreateTaskModal: function () {
      this.patientOpenModal = true;
    },
    closePatientCreateTaskModal: function () {
      this.patientOpenModal = false;
      window.localStorage.removeItem("task_form");
    },
    patientTaskSaved: function () {
      this.patientOpenModal = false;
      window.localStorage.removeItem("task_form");
      this.patientModalKey++;
    },
    getRoleName: function (roleId) {
      let roleName;
      switch (roleId) {
        case 1:
          roleName = "(Admin)";
          break;
        case 2:
          roleName = `(${
            this.$providerLabel
              ? this.$providerLabel({ type: "singular", capitalize: true })
              : "Provider"
          })`;
          break;
        case 5:
          roleName = "(Manager)";
          break;
        default:
          roleName = `(${
            this.$customerLabel
              ? this.$customerLabel({ type: "singular", capitalize: true })
              : "Client"
          })`;
          break;
      }
      return roleName;
    },
    deleteUser: function (id) {
      this.$store.dispatch("Profile/deleteUser", id);
    },
    searchBlured: function () {
      setTimeout(() => {
        this.searchState = "close";
        this.searchKey = "";
      }, 500);
    },
  },
};
</script>

<style lang="scss">
.navbar-app-shell {
  box-sizing: border-box;
  max-width: 100%;
  padding-right: max(1.5rem, env(safe-area-inset-right, 0px)) !important;
  @media (min-width: 992px) {
    padding-right: max(2.25rem, env(safe-area-inset-right, 0px)) !important;
  }
}

.authed-navbar-inner {
  max-width: 100%;
  min-width: 0;
}

.authed-navbar-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  max-width: 100%;
  padding-right: 2px;
}

.authed-navbar-tools {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  flex-shrink: 0;
}

@media (max-width: 570px) {
  .mobile-header-container {
    min-height: 55px;
  }
}

@media (max-width: 991.98px) {
  .no-wrap {
    flex-wrap: nowrap !important;
  }

  .authed-navbar-tools {
    display: flex;
    flex-direction: row;
    margin-top: 0 !important;

    .nav-create-task {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }

    .nav-create-task-item {
      margin-right: 0;
      width: 52px;
      height: 52px;
      text-align: center;
    }

    .search-nav-item {
      width: 52px;
      height: 52px;
    }

    .jump-label[data-state="close"] {
      border-radius: 50%;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
